import $ from 'jquery'
class Accordion {
    constructor() {
        this.$accordion = $('.js-accordion')
        this.$accordionMenu = $('.js-accordion-menu')
    }

    toggle() {

      const breakpoint3 = window.matchMedia( '(max-width:1025px)' );
      let accordion;
        const classCheck = () => {
        if ( breakpoint3.matches === true ) {
          this.$accordion.on('click', function () {
            $(this).next().slideToggle();
          })
          this.$accordionMenu.on('click', function () {
            $(this).next('ul').slideToggle();
            console.log('tue');
          })
        } else if ( breakpoint3.matches === false ) {
            if ( accordion !== undefined ) accordion.destroy( true, true );
            return;
        }
      };  
      breakpoint3.addListener(classCheck);
      classCheck();
    }
}    
export default Accordion